<section class="db-custom-domain-generated-container">
  <div class="header">
    You’re currently using your custom domain
  </div>
  <db-custom-domain-table (recheckStatus)="troubleshootDomaine.emit()"
                          [loading]="troubleshootDomaineLoading"
                          (openNameservers)="openNameservers.emit()"
                          [status]="domain?.status"
                          [pointed]="pointed"
                          [domain]="domain?.main_domain"></db-custom-domain-table>
  <div class="generated-domain-example">
    <div class="label">Your client sites’ URL example</div>
    <div class="value">
      <span>websitename.</span>{{domain.main_domain}}
    </div>
  </div>
</section>
